import React, { useEffect, useCallback, useState} from 'react';
import {useWindowClearer} from "components/sidebar/useWindowClearer.js";
import {connect} from 'react-redux';

const SequencerContextMenu = ({sequencerEngine, dropdownPos, setDropdownPos}) => { 
    useWindowClearer({clear: () => setDropdownPos(undefined), selected: dropdownPos});

    const createPad = useCallback(() => {
        sequencerEngine.createPad();
    }, [createPad]);

    const createPadFromTracks = useCallback(() => {
        sequencerEngine.createPad(sequencerEngine.tracks);
    }, [createPad]);

    if (!dropdownPos) { return []; }

    if (!dropdownPos) { return []; }
    return (
        <div style={{left: dropdownPos.x, top: dropdownPos.y}} className="sequencer-context-menu context-menu">
          <div
            onMouseDown={createPad}
            className="menu-item">
            Create Pad
          </div>
          <div
            onMouseDown={createPadFromTracks}
            className="menu-item">
            Create Pad From Tracks
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SequencerContextMenu);
